import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class CompanyService{
  // API Instance
  configConnection: any = new ConfigConnection();

  get(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  create(company){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}company`, company, config);
  }

  addLogo(company, companyId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    console.log(company, ' ==add logo')
    return axios.post(`${_.configConnection.apiInstance}company/${companyId}/logo`, company, config);
  }

  edit(company, company_id, hasLogo = true){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`,
        'Content-Type': hasLogo ? 'multipart/form-data' : 'application/json',
      }
    };
    return axios.put(`${_.configConnection.apiInstance}company/${company_id}`, company, config);
  }

  getById(company_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company/${company_id}`, config);
  }

  delete_company(company_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.delete(`${_.configConnection.apiInstance}company/${company_id}`, config);
  }

  getBusiness(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}business`, config);
  }

  getInactive(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company/inactive?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  active_company(company_id, reactivate){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company/${company_id}/reactivate`, config);
  }
}
